import React from 'react';
import PropTypes from 'prop-types';
import { FORM_SIZE } from 'src/components/HTKit/Forms/constants';
import InputFieldV2 from 'src/components/HTKit/Forms/InputFieldV2';
import PreQuestionLabelWithHint from './PreQuestionLabelWithHint';

const PreQuestionInput = ({ question, value, onChange, error }) => {
  const hintText = question.get('hint');
  const label = hintText ? (
    <PreQuestionLabelWithHint label={question.get('textDirect')} warning={hintText} />
  ) : (
    question.get('textDirect')
  );

  return (
    <div className="positionRelative">
      <InputFieldV2
        label={label}
        type="text"
        value={value}
        onChange={onChange}
        size={FORM_SIZE.medium}
        error={error}
      />
    </div>
  );
};

PreQuestionInput.propTypes = {
  question: PropTypes.object.isRequired,
  error: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default PreQuestionInput;
